import React, { useState, useRef, useEffect } from "react";
import Tooltip from '@tippyjs/react';
import { ToastContainer, toast } from 'react-toastify';
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Form from "react-validation/build/form";
import 'tippy.js/dist/tippy.css';
import ContentLoader from "react-content-loader";
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import PhoneInput from 'react-phone-input-2'

import { getTrans as t } from "../../../../Localization/translations";
import EditContactService from "../../../../services/party/contact/editContactService";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import { useSubscriptionFeatures } from "../../../../contexts/SubscriptionContext";

function ContactEdit({ id, contact,setHideShowParyContactEdit}) {
  const { planFeatures } = useSubscriptionFeatures();
  const [prefix, setPrefix] = useState("")
  const [first_name, setFirst_name] = useState("")
  const [middle_name, setMiddle_name] = useState("")
  const [last_name, setLast_name] = useState("")
  const [phone_number, setPhone_number] = useState("")
  const [mobile_number, setMobile_number] = useState("")
  const [email, setEmail] = useState("")
  const [createuser, setCreateUser] = useState('')
  const [partycustomer, setPartyCustomer] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  let usercreate = ''
  const checkBtn = useRef();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const form = useRef();

  const handleCancel = () => {
    // setHideShowEdit(true)
    setHideShowParyContactEdit(false)
  }

        const isPortalDisabled = planFeatures !== null && planFeatures.customer_portal === false;

  useEffect(() => {
    setIsLoading(true)
    EditContactService.getPartyContactDetails(contact).then(
      (response) => {
        setPrefix(response.data.prefix)
        setFirst_name(response.data.first_name)
        setMiddle_name(response.data.middle_name)
        setLast_name(response.data.last_name)
        setPhone_number(response.data.phone_number)
        setMobile_number(response.data.mobile_number)
        setEmail(response.data.email)
        setCreateUser(response.data.createpartyuser)
        setPartyCustomer(response.data.party.party_type)
        // setTimeout(() => {
          // }, 1000);
          reset({
            prefix: response.data.prefix,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            email: response.data.email,
            phone_number: response.data.phone_number,
          })
          setIsLoading(false)
      },
    )
  }, [])

  const handleCreateuser = (e) => {
    if (e.target.checked === true) {
      usercreate = 'Yes'
      axios.post(API + "parties/useremailvalidation/", {
        email,

      }, { headers: authHeader(), }).then((response) => {
        if (response.data.success === 0) {
          setCreateUser(true)
        }
        else {
          setCreateUser(true)
        }
      })
    }
    else {
      usercreate = 'No'
      setCreateUser(e.target.checked)
    }
  }
  const handleCreateNewuser = (e) => {
    if (e.target.checked === true) {
      usercreate = 'Yes'
      axios.post(API + "parties/useremailvalidation/", {
        email,

      }, { headers: authHeader(), }).then((response) => {
        if (response.data.success === 0) {

          if (response.data.user_type === "Customer"){

         
          if (response.data.response !==""){

            setCreateUser(true)
          }
          else{
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setCreateUser(false)

          }
        }
        else{
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setCreateUser(false)
          
        }
        }
        else {
          setCreateUser(true)
        }
      })
    }
    else {
      usercreate = 'No'
      setCreateUser(e.target.checked)
    }
  }

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true)
    setDisable(true)
    if (createuser === true) {
      usercreate = 'Yes'
    }
    else {
      if (createuser === 'Yes') {
        usercreate = 'Yes'
      }
      else {
        usercreate = 'No'
      }
    }
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditContactService.editPartyContactDetails(
        contact,
        prefix,
        first_name,
        middle_name,
        last_name,
        phone_number,
        mobile_number,
        email,
        usercreate
      ).then(
        (response) => {
          if (response.data.success) {
            setSuccessful(true);
            setLoading(false);
            setTimeout(() => {
              // setHideShowEdit(true)
              setHideShowParyContactEdit(false)
            }, 2000)
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          }
          else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setSuccessful(false);
            setDisable(false)

          }
        },
      )
    }
  }

  return (
    <>
          <div className="content container-fluid">
            <ToastContainer />
            <div className="header">
              <h5 className="mb-2 pt-3">{t('Edit Contact')}</h5>
            </div>
            <div className="card" role="document">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    {isLoading !== true ?
                    <Form role="form text-left"
                      onSubmit={handleSubmit(handleRegister)}
                      ref={form}
                      action="."
                      method="POST"
                      id="addPartyForm" >
                      {(<>
                        <div className="form-group row">
                          <div className="col-sm-3">
                            <label className="col-form-label">{t('Prefix')} <Tooltip content={t('Prefix_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <select
                              value={prefix}
                              className="form-control form-select"
                              name="prefix"
                              id="id_prefix"
                              {...register("prefix", { onChange: (e) => { setPrefix(e.target.value) }, required: false })}
                            >
                              <option value="">{t('Select Prefix')}</option>
                              <option value="Mr" selected="selected">{t('Mr')}</option>
                              <option value="Mrs" selected="selected">{t('Mrs')}</option>
                              <option value="Ms" selected="selected">{t('Ms')}</option>
                            </select>
                            <div className="invalid-feedback">
                              {errors.prefix?.type === 'required' && "Prefix is required"}
                            </div>
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label required">{t('First Name')} <Tooltip content={t('FirstName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              value={first_name}
                              placeholder={t('First Name')}
                              className="form-control"
                              type="text" name="first_name"
                              maxLength="100"
                              id="id_first_name"
                              {...register("first_name", { onChange: (e) => { setFirst_name(e.target.value) }, required: true })}
                            />
                            <div className="invalid-feedback">
                              {errors.first_name?.type === 'required' && "First Name is required"}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <label className="col-form-label">{t('Middle Name')} <Tooltip content={t('MiddleName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              {...register("middle_name", { required: false })}
                              onChange={(e) => setMiddle_name(e.target.value)}
                              value={middle_name}
                              placeholder={t('Middle Name')}
                              className="form-control"
                              type="text"
                              name="middle_name"
                              maxLength="100"
                              id="id_middle_name"
                            />
                          </div>
                          <div className="col-sm-3">
                            <label className="col-form-label required">{t('Last Name')} <Tooltip content={t('LastName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              value={last_name}
                              placeholder={t('Last Name')}
                              className="form-control"
                              type="text"
                              name="last_name"
                              maxLength="100"
                              id="id_last_name"
                              {...register("last_name", { onChange: (e) => { setLast_name(e.target.value) }, required: true })}
                            />
                            <div className="invalid-feedback">
                              {errors.last_name?.type === 'required' && "Last Name is required"}
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-md-3">
                            <label className="col-form-label ">{t('Phone No')} <Tooltip content={t('PhoneNo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <PhoneInput
                              country={'us'}
                              value={phone_number}
                              onChange={phone => setPhone_number(phone)}
                            />
                            <div className="invalid-feedback">
                              {errors.phone_number?.type === 'required' && "Phone Number is required"}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <label className="col-form-label">{t('Mobile No')} <Tooltip content={t('MobileNo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              {...register("mobile_number", { required: false })}
                              onChange={(e) => setMobile_number(e.target.value)}
                              value={mobile_number}
                              placeholder={t('Mobile No')}
                              className="form-control"
                              type="text"
                              name="mobile_number"
                              maxLength="15"
                              id="id_mobile_number"
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-md-3">
                            <label className="col-form-label required">{t('Email Address')} <Tooltip content={t('EmailAddress_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              className="form-control"
                              type="email"
                              name="email"
                              placeholder={t('Email Address')}
                              maxLength="50"
                              id="id_email"
                              value={email}
                              {...register('email', {
                                onChange: (e) => { setEmail(e.target.value) }, required: "Email is Required",
                                pattern: {
                                  value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                  message: 'Please enter a valid Email'
                                }
                              })}
                            />
                            <span className="invalid-feedback" >{errors.email && errors.email?.message}</span>
                          </div>
                          {
                            partycustomer.includes("Customer") ?

                              createuser === 'Yes' ?
                                <div className="col-md-5">
                                  <div
                                    className="form-check"
                                    style={{ width: "100%", paddingLeft: "2.73em", paddingTop: "2.3em" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="Vehicle"
                                      id="flexRadioDefault1"
                                      // disabled={createuser === "Yes"}
                                      checked={createuser === 'Yes'}
                                      onChange={(e) => {
                                        handleCreateuser(e);
                                      }}
                                    />
                                    <label className="form-check-label tc  font-weight-bold">{t('Customer Portal')}</label>
                                  </div>
                                </div>
                                :
                                <div className="col-md-5">
                                  <div
                                    className="form-check"
                                    style={{ 
                                    width: "100%", 
                                    paddingLeft: "2.73em", 
                                    paddingTop: "2.3em",
                                    opacity: isPortalDisabled ? 0.6 : 1,
                                    cursor: isPortalDisabled ? 'not-allowed' : 'default'
                                  }}
                                  >
                                    <input
                                      className="form-check-input"
                                      value="Yes"
                                      type="checkbox"
                                      name="Vehicle"
                                      id="flexRadioDefault1"
                                      checked={createuser === true}
                                      disabled={isPortalDisabled} 
                                      onChange={(e) => {
                                        // handleCreateuser(e);
                                        handleCreateNewuser(e);
                                      }}
                                      style={{ cursor: isPortalDisabled ? 'not-allowed' : 'pointer' }}
                                    />
                                    <label className="form-check-label tc  font-weight-bold" 
                                    style={{ 
                                      color: isPortalDisabled ? '#9E9E9E' : 'inherit' 
                                    }}>{t('Customer Portal')}
                                    {isPortalDisabled && <span style={{ marginLeft: '5px' }}>🔒</span>}
                                    </label>
                                  </div>
                                </div>
                              : ""
                          }

                        </div>

                        <div className="text-left py-3">
                          <button type="button" className="btn btn-secondary btn-md" onClick={handleCancel} >{t('Cancel')}</button>&nbsp;
                          <button type="submit" disabled={disable} className="border-0 btn btn-primary btn-gradient-primary btn-md">
                            {
                              loading === false ? (
                                t('Update')
                              ) : (
                                <ButtonLoading />
                              )
                            }
                          </button>&nbsp;
                        </div>
                      </>
                      )}
                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </Form>:
                     <ContentLoader
                     viewBox="0 0 1000 550"
                     backgroundColor="rgba(0,0,0,0.06)"
                     foregroundColor="rgba(0,0,0,0.12)"
                   >
                     <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                     <circle cx="879" cy="123" r="11" />
                     <circle cx="914" cy="123" r="11" />
                     <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                     <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                     <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                     <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                     <circle cx="880" cy="184" r="11" />
                     <circle cx="915" cy="184" r="11" />
                     <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                     <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                     <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                     <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                     <circle cx="881" cy="242" r="11" />
                     <circle cx="916" cy="242" r="11" />
                     <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                     <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                     <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                     <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                     <circle cx="882" cy="303" r="11" />
                     <circle cx="917" cy="303" r="11" />
                     <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                     <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                     <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                     <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                     <circle cx="881" cy="363" r="11" />
                     <circle cx="916" cy="363" r="11" />
                     <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                     <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                     <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                     <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                     <circle cx="882" cy="424" r="11" />
                     <circle cx="917" cy="424" r="11" />
                     <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                     <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                     <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                     <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                     <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                     <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                     <circle cx="882" cy="484" r="11" />
                     <circle cx="917" cy="484" r="11" />
                     <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                     <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                     <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                     <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                     <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                     <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                     <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                     <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                     <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                     <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                   </ContentLoader>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
    </>
  )
}

export default ContactEdit
